import { render, staticRenderFns } from "./ExamenEditar.vue?vue&type=template&id=b4a2d442&"
import script from "./ExamenEditar.vue?vue&type=script&lang=js&"
export * from "./ExamenEditar.vue?vue&type=script&lang=js&"
import style0 from "./ExamenEditar.vue?vue&type=style&index=0&id=b4a2d442&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports